<template>
<div>
  <!-- Modal Principal del Producto -->
  <div v-if="modalp" class="modal-backdrop-custom" @click.self="cerrarModal">
    <div class="modal-dialog-custom">
      <div class="modal-content-custom-wrapper">
        <!-- Header -->
        <div class="modal-header-custom brand-purple-bg">
          <button type="button" class="close-btn-white" @click="cerrarModal">×</button>
        </div>

        <!-- Scrollable Body -->
        <div class="modal-body-scrollable">
          <div class="row m-0">
            <!-- Left: Images Gallery -->
            <div class="col-md-5 p-3 p-lg-4">
              <div class="main-image-container mb-3 text-center position-relative" style="cursor: pointer;">
                <img v-if="producto.imagenes && producto.imagenes.length > 0" 
                     :src="`${dominio}/img/productos/${producto.imagenes[selectedImageIndex || 0].nombre}`" 
                     class="img-fluid rounded-premium shadow-sm main-img-fixed" 
                     alt="Producto"
                     @click="verImagenGuia({ imagen: '../productos/' + producto.imagenes[selectedImageIndex || 0].nombre, nombre: producto.nombre })">
                <button v-if="producto.imagenes && producto.imagenes.length > 0" 
                        type="button" 
                        class="btn btn-sm btn-light position-absolute bottom-0 end-0 m-2 shadow-sm rounded-pill font-weight-bold" 
                        @click="verImagenGuia({ imagen: '../productos/' + producto.imagenes[selectedImageIndex || 0].nombre, nombre: producto.nombre })" 
                        style="font-size: 11px;">
                  <i class="fa fa-search-plus text-brand-purple"></i> Ampliar Zoom
                </button>
              </div>
              <div class="thumbnails-grid d-flex gap-2 overflow-auto pb-2 justify-content-center">
                <div v-for="(img, index) in producto.imagenes" :key="index" 
                     class="thumb-item" :class="{'selected': (selectedImageIndex || 0) === index}"
                     @click="selectedImageIndex = index"
                     style="cursor: pointer;">
                  <img :src="`${dominio}/img/productos/${img.nombre}`" class="img-fluid rounded">
                </div>
              </div>
            </div>

            <!-- Right: Details & Config -->
            <div class="col-md-7 p-3 p-lg-4">
              <!-- Selector de Modo si la configuracion es 'ambos' -->
              <div v-if="modoVistaProducto === 'ambos'" class="d-flex mb-3 border rounded p-1 bg-light">
                <button type="button" class="btn btn-sm flex-fill font-weight-bold" :class="activeTab === 'zoom' ? 'btn-success text-white shadow-sm' : 'btn-light text-muted'" @click="activeTab = 'zoom'" style="background-color: #25D366; border-color: #25D366;">
                  <i class="fa fa-calculator me-1"></i> Cotizar Producto
                </button>
                <button type="button" class="btn btn-sm flex-fill font-weight-bold" :class="activeTab === 'cotizar' ? 'btn-brand-purple text-white shadow-sm' : 'btn-light text-muted'" @click="activeTab = 'cotizar'">
                  <i class="fa fa-sliders me-1"></i> Personalizar Producto
                </button>
              </div>

              <h1 class="product-title-premium text-brand-purple mb-1">{{producto.nombre}}</h1>
              <p class="product-subtitle-premium text-muted mb-3">{{ producto.tamano || 'Empaque Personalizado' }}</p>
              
              <!-- MODO COTIZAR PRODUCTO (SECCIÓN PRINCIPAL DE COTIZACIÓN DE EMPAQUES) -->
              <div v-if="modoVistaProducto === 'zoom' || (modoVistaProducto === 'ambos' && activeTab === 'zoom')">
                <div class="product-description-box p-3 bg-light rounded border mb-3">
                  <h6 class="font-weight-bold text-brand-purple mb-2"><i class="fa fa-info-circle me-1"></i> Descripción del Producto:</h6>
                  <p class="text-muted mb-0" style="font-size: 14px; line-height: 1.5;">
                    {{ producto.descripcion || 'Empaque fabricado con materiales premium de alta calidad. Diseñado especialmente para ofrecer máxima resistencia y excelente presentación.' }}
                  </p>
                </div>

                <div class="direct-order-box p-3 p-md-4 rounded mb-3" style="background: linear-gradient(135deg, #e8f8f0 0%, #f4fbf7 100%); border: 2px solid #25D366;">
                  <h5 class="font-weight-bold text-dark mb-2 text-center">
                    <i class="fa fa-calculator text-success me-2" style="font-size: 22px;"></i> Cotizar Producto
                  </h5>
                  <p class="text-muted small text-center mb-3">Selecciona el papel, tintas, acabados y cantidad para agregar a tu lista de cotización.</p>

                  <!-- 1. SELECCIÓN DE PAPEL (Blanco, Crema, Kraft) -->
                  <div class="option-group mb-3 bg-white p-3 rounded border">
                    <label class="attr-label-small d-block text-dark font-weight-bold mb-2">
                      <i class="fa fa-file-text-o text-success me-1"></i> Seleccionar Papel:
                    </label>
                    <div class="d-flex flex-wrap gap-2">
                      <button type="button" 
                              v-for="papelOpt in opcionesPapel" 
                              :key="papelOpt.val" 
                              class="btn btn-sm paper-chip d-flex align-items-center gap-2" 
                              :class="papelSeleccionado === papelOpt.val ? 'selected-green' : ''"
                              @click="papelSeleccionado = papelOpt.val">
                        <span class="color-swatch" :style="{ backgroundColor: papelOpt.color, border: papelOpt.border || '1px solid #ccc' }"></span>
                        <span>{{ papelOpt.label }}</span>
                      </button>
                    </div>
                  </div>

                  <!-- 2. SELECCIÓN DE TINTAS -->
                  <div class="option-group mb-3 bg-white p-3 rounded border">
                    <label class="attr-label-small d-block text-dark font-weight-bold mb-2">
                      <i class="fa fa-paint-brush text-success me-1"></i> Las Tintas:
                    </label>
                    <div class="d-flex flex-wrap gap-2">
                      <button type="button" 
                              v-for="tintaOpt in opcionesTintas" 
                              :key="tintaOpt" 
                              class="btn btn-sm ink-chip" 
                              :class="tintaSeleccionada === tintaOpt ? 'selected-green' : ''"
                              @click="tintaSeleccionada = tintaOpt">
                        {{ tintaOpt }}
                      </button>
                    </div>
                  </div>

                  <!-- 3. OTROS ACABADOS & ANOTACIONES -->
                  <div class="option-group mb-3 bg-white p-3 rounded border">
                    <label class="attr-label-small d-block text-dark font-weight-bold mb-2">
                      <i class="fa fa-magic text-success me-1"></i> Otros Acabados / Cosas Especiales:
                    </label>
                    <div class="d-flex flex-wrap gap-2 mb-2">
                      <button type="button" 
                              v-for="acabadoOpt in opcionesAcabados" 
                              :key="acabadoOpt" 
                              class="btn btn-sm finish-chip" 
                              :class="acabadosSeleccionados.includes(acabadoOpt) ? 'selected-green' : ''"
                              @click="toggleAcabado(acabadoOpt)">
                        <i class="fa" :class="acabadosSeleccionados.includes(acabadoOpt) ? 'fa-check-square' : 'fa-square-o'"></i>
                        {{ acabadoOpt }}
                      </button>
                    </div>

                    <label class="attr-label-small d-block text-dark font-weight-bold mb-1 mt-2">
                      <i class="fa fa-pencil-square-o text-success me-1"></i> Anotar cosas o acabados especiales:
                    </label>
                    <textarea class="form-control custom-textarea-notes" 
                              v-model="notasEspeciales" 
                              rows="2" 
                              placeholder="Anota aquí si lleva otros acabados o detalles especiales..."></textarea>
                  </div>

                  <!-- 4. CANTIDAD DE 1000 EN 1000 -->
                  <div class="quantity-group mb-3 bg-white p-3 rounded border">
                    <label class="attr-label-small d-block text-dark font-weight-bold mb-2">
                      <i class="fa fa-cubes text-success me-1"></i> Cantidad de Producto (De 1.000 en 1.000):
                    </label>
                    <div class="d-flex align-items-center gap-2 mb-2">
                      <button type="button" class="btn btn-outline-success font-weight-bold px-3 py-2 rounded-10" @click="disminuirCantidad">
                        - 1.000
                      </button>
                      <input type="number" 
                             class="form-control text-center quantity-input-stepper font-weight-bold" 
                             step="1000" 
                             min="1000" 
                             v-model.number="cantidad" 
                             style="color: #000000 !important; background-color: #ffffff !important;"
                             @change="validarYCotizar">
                      <button type="button" class="btn btn-outline-success font-weight-bold px-3 py-2 rounded-10" @click="aumentarCantidad">
                        + 1.000
                      </button>
                    </div>
                    <div class="d-flex flex-wrap gap-1 align-items-center">
                      <span class="text-muted small me-1">Rápido:</span>
                      <button type="button" 
                              v-for="preset in [1000, 2000, 3000, 5000, 10000]" 
                              :key="preset" 
                              class="btn btn-xs preset-btn-green" 
                              :class="cantidad === preset ? 'active' : ''"
                              @click="setCantidadPreset(preset)">
                        {{ preset.toLocaleString() }}
                      </button>
                    </div>
                  </div>

                  <!-- 5. AGREGAR A LA LISTA DE COTIZACIÓN -->
                  <button class="btn btn-success btn-lg w-100 py-3 mb-2 rounded font-weight-bold shadow d-flex align-items-center justify-content-center gap-2" 
                          style="background-color: #25D366; border: none; font-size: 16px; border-radius: 12px;" 
                          @click="getDatosProducto">
                    <i class="fa fa-calculator" style="font-size: 22px;"></i> AGREGAR A LA LISTA DE COTIZACIÓN
                  </button>

                  <div class="text-center mt-2">
                    <a :href="whatsappLink" target="_blank" class="btn btn-outline-success btn-sm w-100 font-weight-bold rounded-pill">
                      <i class="fa fa-whatsapp"></i> O consultar este producto directamente por WhatsApp
                    </a>
                  </div>
                </div>
              </div>

              <!-- MODO PERSONALIZAR / COTIZADOR (ORIGINAL RESTAURADO) -->
              <div v-if="modoVistaProducto === 'personalizar' || (modoVistaProducto === 'ambos' && activeTab === 'cotizar')">
                <div class="price-section mb-3">
                  <span class="price-from">Desde</span>
                  <span class="price-main text-brand-green"> ${{ minPrecioCalculado.toLocaleString() }} USD</span>
                  <span class="price-unit"> / Unidad</span>
                </div>

                <div class="info-badges-row mb-3">
                  <span class="info-badge-item"><i class="fa fa-check"></i> Mínimo: 100</span>
                  <span class="info-badge-item ms-3"><i class="fa fa-clock-o"></i> Entrega: 10-15 días</span>
                </div>

                <!-- Selector Section -->
                <div class="attributes-grid row">
                  <div class="col-6 mb-2" v-for="(items, tipo) in atributosTienda" :key="tipo">
                    <div class="d-flex align-items-center mb-1">
                      <label class="attr-label-small mb-0">{{ tipo }}</label>
                    </div>
                    <div class="select-wrapper-premium">
                      <template v-if="items[0] && items[0].seleccion_multiple">
                        <div class="multiple-selection-container p-2 border rounded bg-light" style="max-height: 120px; overflow-y: auto;">
                          <div v-for="item in items" :key="item.id" class="form-check mb-1">
                            <input class="form-check-input" type="checkbox" :id="'web_attr_'+item.id" :value="item.nombre" v-model="specsSeleccionadas[tipo]" @change="cotizarPrecio">
                            <label class="form-check-label d-flex align-items-center" :for="'web_attr_'+item.id" style="font-size: 12px; font-weight: 600;">
                              {{ item.nombre }} 
                              <small v-if="item.valor_extra > 0" class="text-success ms-1">(+${{item.valor_extra}})</small>
                              <i v-if="item.imagen" class="fa fa-image ms-2 text-brand-purple" :title="'Ver guía de ' + item.nombre" @click.stop="verImagenGuia(item)"></i>
                            </label>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="custom-dropdown-premium">
                          <div class="dropdown-trigger-premium" @click.stop="toggleDropdown(tipo)" :class="{'active': dropdownsOpen[tipo]}">
                            <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                              <span class="text-truncate">{{ specsSeleccionadas[tipo] || ('Seleccione ' + tipo) }}</span>
                            </div>
                            <i class="fa" :class="dropdownsOpen[tipo] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                          </div>
                          <div v-if="dropdownsOpen[tipo]" class="dropdown-menu-premium shadow-lg" @click.stop>
                            <div class="dropdown-option-premium" :class="{'selected': specsSeleccionadas[tipo] === ''}" @click="selectOption(tipo, '')">
                              <span>Seleccione {{ tipo }}</span>
                            </div>
                            <div v-for="item in items" :key="item.id" 
                                 class="dropdown-option-premium" 
                                 :class="{'selected': specsSeleccionadas[tipo] === item.nombre}"
                                 @click="selectOption(tipo, item.nombre)">
                              <div v-if="item.imagen" class="circle-guide-thumb-small me-2">
                                <img :src="`${dominio}/img/atributos/${item.imagen}`">
                                <div class="zoom-indicator-mini" @click.stop="verImagenGuia(item)"><i class="fa fa-search"></i></div>
                              </div>
                              <span class="option-text">{{ item.nombre }}</span>
                              <small v-if="item.valor_extra > 0" class="text-success ms-auto">+${{item.valor_extra}}</small>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="col-6 mb-2">
                    <label class="attr-label-small">Cantidad</label>
                    <input type="number" class="form-control premium-select-input-compact" v-model="cantidad" @change="cotizarPrecio">
                  </div>
                </div>

                <!-- Barra de Estado Interactiva -->
                <div class="status-bar-premium mt-3 mb-3">
                  <div v-if="loading" class="searching-indicator">
                    <i class="fa fa-spinner fa-spin"></i> 
                    <span v-if="!producto.valor_total">Buscando en el historial...</span>
                    <span v-else>Recalculando costos...</span>
                  </div>
                  <div v-else-if="matchFound" class="match-found-indicator">
                    <i class="fa fa-check-circle"></i> ¡Coincidencia encontrada! (Orden ID: #{{ ordenMatchId }})
                  </div>
                  <div v-else-if="cotizacionMensaje" class="no-match-indicator w-100">
                    <div class="d-flex align-items-center mb-1" style="font-weight: 700;">
                      <i class="fa fa-calculator me-2"></i> {{ cotizacionMensaje }}
                    </div>
                  </div>
                </div>

                <div class="action-footer mt-2">
                  <div class="config-summary-box-web p-3 mb-3 border rounded shadow-sm" v-if="resumenConfiguracion" style="background: #fdfaff; border-color: #7d3c98 !important;">
                    <h6 class="mb-2 text-brand-purple" style="font-weight: 800; font-size: 12px; text-transform: uppercase;">
                      <i class="fa fa-list-alt"></i> Detalles del trabajo:
                    </h6>
                    <p class="mb-0 text-dark" style="font-size: 13px; line-height: 1.4; font-weight: 600;">
                      {{ resumenConfiguracion }}
                    </p>
                  </div>
                  <div class="price-details-box mb-3 p-3 rounded shadow-sm bg-light border">
                    <div class="d-flex justify-content-between mb-1">
                      <span class="text-muted">Valor Unitario:</span>
                      <span class="fw-bold text-dark">${{ valorUnitarioMatch.toLocaleString() }} USD</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="fw-bold h5 mb-0">TOTAL:</span>
                      <span class="total-amount-display text-brand-green">${{ (producto.valor_total || 0).toLocaleString() }} USD</span>
                    </div>
                  </div>

                  <button class="btn-add-to-cart-premium w-100 mb-2" @click="getDatosProducto">
                    <i class="fa fa-shopping-cart"></i> AGREGAR AL CARRITO
                  </button>
                  
                  <div class="text-center mt-2">
                    <a :href="whatsappLink" target="_blank" class="text-success small font-weight-bold text-decoration-none">
                      <i class="fa fa-whatsapp"></i> ¿Dudas? Consultar con un asesor por WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 6. MODAL / DIÁLOGO DE CONFIRMACIÓN AL AGREGAR AL CARRITO DE COTIZACIÓN -->
  <div v-if="modalConfirmacionCarrito" class="modal-backdrop-custom" style="z-index: 12000;">
    <div class="modal-dialog-custom text-center p-4" style="max-width: 500px; background: white; border-radius: 24px; box-shadow: 0 20px 60px rgba(0,0,0,0.4); animation: popIn 0.3s ease-out;">
      <div class="success-icon-badge mx-auto mb-3" style="width: 75px; height: 75px; background: #e8f8f0; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
        <i class="fa fa-check-circle text-success" style="font-size: 45px;"></i>
      </div>
      <h4 class="font-weight-bold text-dark mb-2">¡Producto Agregado para Cotización!</h4>
      <p class="text-muted small mb-3">Se ha añadido correctamente a tu carrito para cotizar por WhatsApp.</p>
      
      <div v-if="productoAgregadoData" class="p-3 bg-light rounded-15 text-start mb-4 border" style="font-size: 13px; border-color: #e2d5ed !important;">
        <div class="fw-bold text-brand-purple mb-2 h6">{{ productoAgregadoData.nombre }}</div>
        <div class="d-flex justify-content-between mb-1">
          <span class="text-muted">Cantidad:</span>
          <span class="font-weight-bold text-dark">{{ productoAgregadoData.cantidad.toLocaleString() }} Unidades</span>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <span class="text-muted">Papel:</span>
          <span class="font-weight-bold text-dark">{{ productoAgregadoData.papel }}</span>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <span class="text-muted">Tintas:</span>
          <span class="font-weight-bold text-dark">{{ productoAgregadoData.tinta }}</span>
        </div>
        <div v-if="productoAgregadoData.acabados && productoAgregadoData.acabados.length > 0" class="d-flex justify-content-between mb-1">
          <span class="text-muted">Acabados:</span>
          <span class="font-weight-bold text-dark">{{ productoAgregadoData.acabados.join(', ') }}</span>
        </div>
        <div v-if="productoAgregadoData.notas" class="mb-1 border-top pt-1 mt-1">
          <span class="text-muted d-block small font-weight-bold">Notas Especiales:</span>
          <span class="text-dark small font-italic">"{{ productoAgregadoData.notas }}"</span>
        </div>
        <div class="d-flex justify-content-between border-top pt-2 mt-2">
          <span class="font-weight-bold text-dark">Precio:</span>
          <span class="font-weight-bold text-warning h6 mb-0"><i class="fa fa-calculator me-1"></i> Por Cotizar</span>
        </div>
      </div>

      <!-- BOTONES DE ACCIÓN: SEGUIR COMPRANDO / IR AL CARRITO -->
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-outline-purple flex-fill py-3 rounded-pill font-weight-bold" @click="seguirComprando">
          <i class="fa fa-shopping-bag me-1"></i> Seguir Comprando
        </button>
        <button type="button" class="btn btn-success flex-fill py-3 rounded-pill font-weight-bold shadow" @click="irAlCarrito" style="background-color: #25D366; border: none;">
          <i class="fa fa-shopping-cart me-1"></i> Ir al Carrito
        </button>
      </div>
    </div>
  </div>

  <!-- Modal de Imagen Guía -->
  <div v-if="modalImagenGuia" class="modal-backdrop-custom" style="z-index: 11000;" @click="modalImagenGuia = false">
    <div class="modal-dialog-custom" style="max-width: 500px; background: transparent; box-shadow: none;">
      <div class="text-end mb-2">
        <button class="btn btn-light btn-sm rounded-circle" @click="modalImagenGuia = false">×</button>
      </div>
      <img :src="imagenGuiaUrl" class="img-fluid rounded shadow-lg border-white border-4" style="max-height: 80vh; object-fit: contain;">
      <div class="bg-white p-3 mt-2 rounded text-center fw-bold text-brand-purple shadow-sm">
        {{ imagenGuiaTitulo }}
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import Vue from 'vue'

export default {
    props: {
        modalp: 0,
        producto: {},
        scroll: 0
    },
    data() {
        return {
            cantidad: 1000,
            papelSeleccionado: 'Blanco',
            opcionesPapel: [
                { label: 'Blanco', val: 'Blanco', color: '#ffffff', border: '2px solid #ddd' },
                { label: 'Crema', val: 'Crema', color: '#f5f2eb', border: '2px solid #e0d8c3' },
                { label: 'Kraft', val: 'Kraft', color: '#c49a6c', border: '2px solid #a67c46' }
            ],
            tintaSeleccionada: '1 Tinta',
            opcionesTintas: ['1 Tinta', '2 Tintas', '3 Tintas', '4 Tintas (CMYK)', 'Sin Tinta'],
            acabadosSeleccionados: [],
            opcionesAcabados: ['Plastificado Mate', 'Plastificado Brillante', 'Stamping', 'Barniz UV', 'Repujado'],
            notasEspeciales: '',
            atributosTienda: {},
            specsSeleccionadas: {},
            matchFound: false,
            minPrecioCalculado: 0,
            valorUnitarioMatch: 0,
            loading: false,
            ordenMatchId: 0,
            modalImagenGuia: false,
            imagenGuiaUrl: '',
            imagenGuiaTitulo: '',
            dropdownsOpen: {},
            cotizacionMensaje: '',
            detallesCalculo: null,
            selectedImageIndex: 0,
            activeTab: 'zoom',
            modalConfirmacionCarrito: false,
            productoAgregadoData: null
        }
    },
    computed: {
        ...mapState(['dominio', 'configTienda']),
        modoVistaProducto() {
            return (this.configTienda && this.configTienda.modo_vista_producto) || 'ambos';
        },
        numeroWhatsApp() {
            return (this.configTienda && this.configTienda.numero_whatsapp) || '';
        },
        whatsappLink() {
            let num = this.numeroWhatsApp ? this.numeroWhatsApp.replace(/[^0-9]/g, '') : '';
            let detalles = `*Producto:* ${this.producto.nombre || ''}\n*Cantidad:* ${this.cantidad.toLocaleString()} unidades\n*Papel:* ${this.papelSeleccionado}\n*Tintas:* ${this.tintaSeleccionada}`;
            if (this.acabadosSeleccionados && this.acabadosSeleccionados.length > 0) {
                detalles += `\n*Acabados:* ${this.acabadosSeleccionados.join(', ')}`;
            }
            if (this.notasEspeciales) {
                detalles += `\n*Notas:* ${this.notasEspeciales}`;
            }
            let text = encodeURIComponent(`Hola! Deseo cotizar / pedir información:\n\n${detalles}`);
            if (num) {
                return `https://wa.me/${num}?text=${text}`;
            }
            return `https://api.whatsapp.com/send?text=${text}`;
        },
        resumenConfiguracion() {
            let parts = [];
            Object.keys(this.specsSeleccionadas).forEach(tipo => {
                let val = this.specsSeleccionadas[tipo];
                if (val) {
                    if (Array.isArray(val)) {
                        if (val.length > 0) {
                            parts.push(`${tipo.toLowerCase()} ${val.join(', ')}`);
                        }
                    } else {
                        parts.push(`${tipo.toLowerCase()} ${val}`);
                    }
                }
            });
            return parts.length > 0 ? parts.join(', ') : '';
        }
    },
    watch: {
        modalp(val) {
            if (val) {
                this.selectedImageIndex = 0;
                this.activeTab = 'zoom';
                this.specsSeleccionadas = {};
                this.cantidad = 1000;
                this.papelSeleccionado = 'Blanco';
                this.tintaSeleccionada = '1 Tinta';
                this.acabadosSeleccionados = [];
                this.notasEspeciales = '';
                this.matchFound = false;
                this.ordenMatchId = 0;
                this.modalConfirmacionCarrito = false;
                
                this.getAtributosTienda();
                this.getMinPrecio();
                this.cotizarPrecio();
            }
        }
    },
    methods: {
        toggleAcabado(acabado) {
            let idx = this.acabadosSeleccionados.indexOf(acabado);
            if (idx > -1) {
                this.acabadosSeleccionados.splice(idx, 1);
            } else {
                this.acabadosSeleccionados.push(acabado);
            }
        },
        aumentarCantidad() {
            this.cantidad = (parseInt(this.cantidad) || 0) + 1000;
        },
        disminuirCantidad() {
            if (this.cantidad > 1000) {
                this.cantidad = (parseInt(this.cantidad) || 1000) - 1000;
            }
        },
        setCantidadPreset(val) {
            this.cantidad = val;
        },
        validarYCotizar() {
            if (!this.cantidad || this.cantidad < 1000) {
                this.cantidad = 1000;
            }
        },
        getAtributosTienda() {
            let me = this;
            if (!this.producto || !this.producto.id) return;
            axios.get(this.dominio + '/api/tienda/atributos', {
                params: {
                    articulo_id: this.producto.id
                }
            }).then(response => {
                if (response && response.data) {
                    me.atributosTienda = response.data;
                    Object.keys(response.data).forEach(tipo => {
                        if (response.data[tipo] && response.data[tipo][0]) {
                            let esMultiple = response.data[tipo][0].seleccion_multiple;
                            if (me.specsSeleccionadas[tipo] === undefined) {
                                Vue.set(me.specsSeleccionadas, tipo, esMultiple ? [] : '');
                            }
                            Vue.set(me.dropdownsOpen, tipo, false);
                        }
                    });
                }
            }).catch(err => {
                console.warn('Atributos opcionales de tienda no encontrados:', err);
            });
        },
        getMinPrecio() {
            let me = this;
            if (!this.producto || !this.producto.id) return;
            axios.get(this.dominio + '/api/tienda/min-precio/' + this.producto.id).then(response => {
                if (response && response.data) {
                    me.minPrecioCalculado = response.data.min_precio || 0;
                }
            }).catch(err => {
                console.warn('Precio base no encontrado:', err);
            });
        },
        cotizarPrecio() {
            let me = this;
            if (!me.producto || !me.producto.id) return;
            
            me.loading = true;
            me.cotizacionMensaje = 'Cotizando...';

            let especificaciones = [];
            Object.keys(me.specsSeleccionadas).forEach(key => {
                let val = me.specsSeleccionadas[key];
                if (val) {
                    especificaciones.push({ titulo: key, valor: val });
                }
            });

            axios.post(this.dominio + '/api/tienda/cotizar', {
                articulo_id: this.producto.id,
                cantidad: this.cantidad,
                especificaciones: especificaciones
            }).then(response => {
                me.loading = false;
                if (response.data) {
                    me.producto.valor_total = response.data.total || 0;
                    me.valorUnitarioMatch = response.data.valor_unitario || 0;
                    me.matchFound = response.data.match_found || false;
                    me.ordenMatchId = response.data.orden_referencia || 0;
                    
                    if (!me.matchFound) {
                        me.cotizacionMensaje = response.data.mensaje || 'Cálculo de producción aplicado.';
                        me.detallesCalculo = response.data.detalles_calculo;
                    } else {
                        me.cotizacionMensaje = '¡Precio histórico encontrado!';
                        me.detallesCalculo = null;
                    }
                }
            }).catch(error => {
                console.error("Error en cotización:", error);
                me.loading = false;
                me.cotizacionMensaje = 'Error en el cálculo. Revise su conexión.';
            });
        },
        toggleDropdown(tipo) {
            let currentState = this.dropdownsOpen[tipo];
            Object.keys(this.dropdownsOpen).forEach(k => {
                this.dropdownsOpen[k] = false;
            });
            this.dropdownsOpen[tipo] = !currentState;
        },
        closeDropdown(tipo) {
            this.dropdownsOpen[tipo] = false;
        },
        selectOption(tipo, nombre) {
            this.specsSeleccionadas[tipo] = nombre;
            this.dropdownsOpen[tipo] = false;
            this.cotizarPrecio();
        },
        verImagenGuia(item) {
            this.imagenGuiaUrl = `${this.dominio}/img/atributos/${item.imagen}`;
            this.imagenGuiaTitulo = `${item.tipo}: ${item.nombre}`;
            this.modalImagenGuia = true;
        },
        cerrarModal() {
            this.$emit('cerrarModalp')
        },
        getDatosProducto() {
            let esCotizarTab = (this.modoVistaProducto === 'zoom' || (this.modoVistaProducto === 'ambos' && this.activeTab === 'zoom'));

            let especificaciones = {
                'Papel': this.papelSeleccionado,
                'Tintas': this.tintaSeleccionada,
                'Acabados': this.acabadosSeleccionados.length > 0 ? this.acabadosSeleccionados.join(', ') : 'Ninguno',
                'Notas Especiales': this.notasEspeciales || '',
                ...this.specsSeleccionadas
            };

            let itemCarrito = {
                ...this.producto,
                cantidad: this.cantidad,
                wanted: this.cantidad,
                papel: this.papelSeleccionado,
                tinta: this.tintaSeleccionada,
                acabados: [...this.acabadosSeleccionados],
                notas: this.notasEspeciales,
                specs: especificaciones,
                esCotizacion: esCotizarTab
            };

            if (esCotizarTab) {
                itemCarrito.price = 0;
                itemCarrito.valor_unitario = 0;
                itemCarrito.valor_total = 0;
                itemCarrito.precio_venta = 0;
            } else {
                let priceValue = this.valorUnitarioMatch || this.producto.precio_venta || this.producto.price || 0;
                itemCarrito.price = priceValue;
                itemCarrito.valor_unitario = priceValue;
                itemCarrito.valor_total = this.producto.valor_total || (priceValue * this.cantidad);
            }

            // Guardar en el store de Vuex
            this.$store.commit('saveToCart', { product: itemCarrito, quantity: this.cantidad });
            this.$emit('productoCustom', itemCarrito);

            // Mostrar modal de confirmación
            this.productoAgregadoData = itemCarrito;
            this.modalConfirmacionCarrito = true;
        },
        seguirComprando() {
            this.modalConfirmacionCarrito = false;
            this.cerrarModal();
        },
        irAlCarrito() {
            this.modalConfirmacionCarrito = false;
            this.cerrarModal();
            if (this.$router) {
                this.$router.push({ name: 'checkout' }).catch(() => {});
            }
        },
        closeAllDropdowns() {
            Object.keys(this.dropdownsOpen).forEach(k => {
                this.dropdownsOpen[k] = false;
            });
        }
    },
    mounted() {
        document.addEventListener('click', this.closeAllDropdowns);
    },
    destroyed() {
        document.removeEventListener('click', this.closeAllDropdowns);
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;800&display=swap');
.modal-dialog-custom { font-family: 'Montserrat', sans-serif !important; }

/* Modal Layout */
.modal-backdrop-custom { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0, 0, 0, 0.7); display: flex; align-items: center; justify-content: center; z-index: 10000; padding: 10px; }
.modal-dialog-custom { width: 100%; max-width: 900px; max-height: 95vh; background: white; border-radius: 25px; overflow: hidden; box-shadow: 0 10px 40px rgba(0,0,0,0.4); display: flex; flex-direction: column; }
.modal-content-custom-wrapper { display: flex; flex-direction: column; height: 100%; overflow: hidden; }

/* Header */
.brand-purple-bg { background-color: #7d3c98 !important; }
.modal-header-custom { padding: 12px 20px; display: flex; justify-content: flex-end; align-items: center; min-height: 50px; }
.close-btn-white { background: none; border: none; color: white !important; font-size: 32px; cursor: pointer; }

/* Body */
.modal-body-scrollable { overflow-y: auto; flex-grow: 1; padding-bottom: 20px; }
.text-brand-purple { color: #7d3c98 !important; }
.text-brand-green { color: #6ab04c !important; }
.product-title-premium { font-size: 28px; font-weight: 800; line-height: 1.1; }

/* Status Bar Indicators */
.status-bar-premium { font-size: 13px; font-weight: 600; min-height: 20px; }
.searching-indicator { color: #7d3c98; }
.match-found-indicator { color: #166534; background: #f0fdf4; padding: 5px 10px; border-radius: 5px; display: inline-block; }
.no-match-indicator { color: #856404; background: #fff3cd; padding: 5px 10px; border-radius: 5px; display: inline-block; }

/* Styling Chips and Options */
.paper-chip, .ink-chip, .finish-chip {
  border: 1.5px solid #25D366;
  background: #ffffff;
  color: #333;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s ease;
}
.paper-chip:hover, .ink-chip:hover, .finish-chip:hover {
  background: #e8f8f0;
}
.paper-chip.selected-green, .ink-chip.selected-green, .finish-chip.selected-green {
  background: #25D366 !important;
  color: #ffffff !important;
  border-color: #25D366 !important;
  box-shadow: 0 4px 10px rgba(37, 211, 102, 0.3);
}
.color-swatch {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-block;
}
.custom-textarea-notes {
  border: 2px solid #25D366 !important;
  border-radius: 12px !important;
  font-size: 13px !important;
  background-color: #fafafa !important;
}
.custom-textarea-notes:focus {
  background-color: #fff !important;
  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.2) !important;
}
.quantity-input-stepper {
  border: 2px solid #25D366 !important;
  border-radius: 10px !important;
  height: 44px;
  font-weight: 800;
  font-size: 16px;
  color: #000000 !important;
  background-color: #ffffff !important;
  max-width: 130px;
}
.btn-outline-success {
  border: 2px solid #25D366;
  color: #25D366;
  background: white;
  transition: 0.2s;
}
.btn-outline-success:hover {
  background: #25D366;
  color: white;
}
.btn-outline-purple {
  border: 2px solid #7d3c98;
  color: #7d3c98;
  background: white;
  transition: 0.2s;
}
.btn-outline-purple:hover {
  background: #7d3c98;
  color: white;
}
.preset-btn-green {
  border: 1px solid #25D366;
  color: #1b8a43;
  border-radius: 12px;
  font-weight: 700;
  padding: 3px 8px;
  font-size: 11px;
}
.preset-btn-green.active, .preset-btn-green:hover {
  background: #25D366;
  color: white;
}

/* Inputs */
.premium-select-input-compact { border: 2px solid #7d3c98 !important; border-radius: 12px !important; height: 44px !important; font-size: 13px !important; font-weight: 600 !important; color: #000 !important; background-color: #f5f5f5 !important; }
.attr-label-small { font-weight: 800; font-size: 13px; margin-bottom: 5px; color: #000 !important; }

/* Price Box */
.price-details-box { background: #fafafa; border: 1px solid #eee; }
.total-amount-display { font-size: 24px; font-weight: 800; }

/* Button */
.btn-add-to-cart-premium { background: #7d3c98; color: white !important; border: none; padding: 15px; border-radius: 35px; font-size: 18px; font-weight: 800; transition: 0.3s; cursor: pointer; }
.btn-add-to-cart-premium:hover { background: #6a3381; transform: translateY(-2px); }

/* Images */
.rounded-premium { border-radius: 20px; }
.main-img-fixed { max-height: 250px; object-fit: contain; }
.thumb-item { width: 70px; height: 70px; border: 2px solid #f0f0f0; border-radius: 12px; margin-right: 5px; }

/* Custom Dropdown */
.custom-dropdown-premium { position: relative; width: 100%; }
.dropdown-trigger-premium { border: 2px solid #7d3c98 !important; border-radius: 12px !important; height: 48px; padding: 0 15px; display: flex; align-items: center; justify-content: space-between; cursor: pointer; background: #f5f5f5; font-weight: 600; font-size: 14px; transition: 0.3s; }
.dropdown-trigger-premium:hover { background: #fff; }
.dropdown-trigger-premium.active { border-color: #6ab04c !important; background: #fff; }
.dropdown-menu-premium { position: absolute; top: 110%; left: 0; width: 100%; background: white; border-radius: 15px; z-index: 100; max-height: 250px; overflow-y: auto; border: 1px solid #eee; }
.dropdown-option-premium { padding: 10px 15px; display: flex; align-items: center; cursor: pointer; transition: 0.2s; border-bottom: 1px solid #f9f9f9; }
.dropdown-option-premium:hover { background: #fdfaff; }
.dropdown-option-premium.selected { background: #f3e5f5; color: #7d3c98; font-weight: 800; }
.option-text { font-size: 13px; font-weight: 600; }

@keyframes popIn {
  0% { transform: scale(0.85); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
</style>
